import React, { useEffect, useState } from "react";
import "./Dashboard.scss";
import TotalCountRings from "../../components/TotalCountRings/TotalCountRings";
import SevenDayGraph from "../../components/SevenDayGraph/SevenDayGraph";
import DashCards from "./DashCards";
import axiosInstace from "../../axiosInstace";
import DashboardSkeleton from "../../components/DashboardSkeleton/DashboardSkeleton";
import { FiCalendar } from "react-icons/fi";

function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
}

function formatDate() {
  return new Date().toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export default function Dashboard() {
  const [counts, setCounts] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // pull user name from session if available
  const userName = (() => {
    try {
      const stored = JSON.parse(sessionStorage.getItem("user") || "null");
      return stored?.name ?? stored?.empName ?? null;
    } catch {
      return null;
    }
  })();

  useEffect(() => {
    let mounted = true;
    async function fetchSummary() {
      setLoading(true);
      setError(null);
      try {
        const res = await axiosInstace.get("/api/emp/counts/summary");
        const data = res?.data?.data ?? {};

        const normalized = {
          projects: {
            total: Number(data?.projects?.total ?? 0),
            completed: Number(data?.projects?.completed ?? 0),
            active: Number(data?.projects?.active ?? 0),
          },
          tasks: {
            total: Number(data?.tasks?.total ?? 0),
            completed: Number(data?.tasks?.completed ?? 0),
            overdue: Number(data?.tasks?.overdue ?? 0),
            dueToday: Number(data?.tasks?.dueToday ?? 0),
          },
          todos: {
            total: Number(data?.todos?.total ?? 0),
            completed: Number(data?.todos?.completed ?? 0),
            overdue: Number(data?.todos?.overdue ?? 0),
          },
          todolists: {
            total: Number(data?.todolists?.total ?? 0),
            active: Number(data?.todolists?.active ?? 0),
          },
        };

        if (!mounted) return;
        setCounts(normalized);
      } catch (err) {
        console.error("Failed to fetch dashboard summary", err);
        if (!mounted) return;
        setError("Unable to load dashboard summary");
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    }

    fetchSummary();
    return () => (mounted = false);
  }, []);

  if (loading) return <DashboardSkeleton />;
  if (error)
    return (
      <div className="dashboard-page" style={{ padding: 32 }}>
        Error: {error}
      </div>
    );

  const smallCounts = {
    projects: counts.projects.total,
    tasks: counts.tasks.total,
    todos: counts.todos.total,
  };

  return (
    <div className="dashboard-page">
      {/* Greeting bar */}
      <div className="dashboard-greeting">
        <div className="dashboard-greeting-text">
          <h1>
            {getGreeting()}
            {userName ? `, ${userName}` : ""}
          </h1>
          <p>Here's what's happening across your projects today.</p>
        </div>
        <div className="dashboard-date-chip">
          <FiCalendar aria-hidden="true" />
          {formatDate()}
        </div>
      </div>

      {/* TOP: donut (left) + graph (right) */}
      <div className="dashboard-row dashboard-top-row">
        <div className="donut-column">
          <TotalCountRings counts={smallCounts} />
        </div>
        <div className="graph-column">
          <SevenDayGraph />
        </div>
      </div>

      {/* BOTTOM: stat cards */}
      <div className="dashboard-row dashboard-cards-row">
        <div className="dashcards-container">
          <DashCards counts={counts} />
        </div>
      </div>
    </div>
  );
}
